/**
 * External dependencies
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Box, Text } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import { isSectionLoading, getSectionName, getCurrentPath } from 'state/ui/selectors';
import DocumentHead from 'data/document-head';
import GlobalNotices from 'blocks/global-notices';
import { getPreference } from 'state/preferences/selectors';
import UserMenuDropdown from 'blocks/user-menu-dropdown';
import logo from 'assets/images/tower_logo_white.png';
import Icon from 'components/icon';
import LoggedInTopbar from './topbar/logged-in';


class Layout extends Component {
	static propTypes = {
		primary: PropTypes.element,
		secondary: PropTypes.element,
	};

	componentDidMount() {
		if (typeof document !== 'undefined') {
			if (this.props.colorSchemePreference) {
				document.querySelector('body').classList.add(`is-${this.props.colorSchemePreference}`);
			}
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.colorSchemePreference === this.props.colorSchemePreference) {
			return;
		}
		if (typeof document !== 'undefined') {
			const classList = document.querySelector('body').classList;
			classList.remove(`is-${prevProps.colorSchemePreference}`);
			classList.add(`is-${this.props.colorSchemePreference}`);
		}
	}

	render() {
		const hasSidebar = !!this.props.sidebar;

		const sectionClass = classnames(
			'layout',
			`is-section-${this.props.sectionName}`,
			{ 'has-sidebar': hasSidebar },
		);

		const loadingClass = classnames({
			layout__loader: true,
			'is-active': this.props.isLoading,
		});

		return (
			<div className={sectionClass}>
				<DocumentHead />
				<GlobalNotices />
				<LoggedInTopbar />
				<div class='master-topbar'>
					<Box display='flex' flexDirection='row' alignItems='center'>
						<img src={logo} alt='Tower Systems' height={65} width={65} />
						<h3 className='pl-3 topbar__heading'>Tower Web Connect</h3>
					</Box>
					<UserMenuDropdown />
				</div>
				<div className={loadingClass}>{this.props.isLoading && <div>loading!</div>}</div>
				<div id='content' className='layout__content'>
					<div id='sidebar' className='layout__sidebar'>
						{this.props.secondary}
					</div>
					<div id='primary' className='layout__primary'>
						{this.props.primary}
					</div>
				</div>
				<footer className='footer__container'>
					<div className='footer__content'>
						<span>© TOWER SYSTEMS PTY LTD. <a href="//towersystems.com.au/terms-and-conditions.html">Terms & Conditions</a></span>
					</div>
				</footer>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		isLoading: isSectionLoading(state),
		sectionName: getSectionName(state),
		path: getCurrentPath(state),
		colorSchemePreference: getPreference(state, 'colorScheme'),
	};
};

export default connect(mapStateToProps, {})(Layout);
